import React from 'react';
import { Flame, Users } from 'lucide-react';
interface UrgencyBandProps {
  timeLeft: {
    hours: number;
    minutes: number;
    seconds: number;
  };
}
export function UrgencyBand({
  timeLeft
}: UrgencyBandProps) {
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <section className="bg-dark text-white px-3 md:px-4 py-3 md:py-4 border-y-2 border-gold relative overflow-hidden" data-id="element-356">
      {/* Subtle pulse glow */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-gold/5 to-transparent animate-pulse pointer-events-none" data-id="element-357"></div>

      <div className="max-w-6xl mx-auto relative z-10 flex flex-col md:flex-row items-center justify-between gap-2 md:gap-4" data-id="element-358">
        {/* Left: Urgency label */}
        <div className="flex items-center gap-2 md:gap-3 shrink-0" data-id="element-359">
          <div className="bg-red-600 text-white font-bold px-2 py-0.5 rounded text-[10px] md:text-xs uppercase tracking-wider animate-pulse flex items-center gap-1" data-id="element-360">
            <Flame size={11} fill="currentColor" data-id="element-361" />
            <span data-id="element-362">+$8.000 DESPUÉS</span>
          </div>
          <div className="text-left" data-id="element-363">
            <p className="font-display text-sm md:text-base text-white uppercase leading-none" data-id="element-364">
              Lanzamiento termina en
            </p>
            <p className="text-[9px] md:text-[10px] text-gold font-medium leading-tight" data-id="element-365">
              Y no vuelve a bajar
            </p>
          </div>
        </div>

        {/* Center: Compact countdown */}
        <div className="flex items-center gap-1 md:gap-1.5 shrink-0" data-id="element-366">
          <div className="bg-gray-800 border border-gray-700 px-2 md:px-2.5 py-1 md:py-1.5 rounded-md flex flex-col items-center min-w-[40px] md:min-w-[48px]" data-id="element-367">
            <span className="font-display text-lg md:text-2xl text-white leading-none" data-id="element-368">
              {formatTime(timeLeft.hours)}
            </span>
            <span className="text-[8px] md:text-[9px] text-gray-400 uppercase font-bold tracking-wider mt-0.5" data-id="element-369">
              Hs
            </span>
          </div>
          <span className="font-display text-gray-600 text-lg md:text-xl" data-id="element-370">
            :
          </span>
          <div className="bg-gray-800 border border-gray-700 px-2 md:px-2.5 py-1 md:py-1.5 rounded-md flex flex-col items-center min-w-[40px] md:min-w-[48px]" data-id="element-371">
            <span className="font-display text-lg md:text-2xl text-white leading-none" data-id="element-372">
              {formatTime(timeLeft.minutes)}
            </span>
            <span className="text-[8px] md:text-[9px] text-gray-400 uppercase font-bold tracking-wider mt-0.5" data-id="element-373">
              Min
            </span>
          </div>
          <span className="font-display text-gray-600 text-lg md:text-xl" data-id="element-374">
            :
          </span>
          <div className="bg-gray-800 border border-gold/40 px-2 md:px-2.5 py-1 md:py-1.5 rounded-md flex flex-col items-center min-w-[40px] md:min-w-[48px]" data-id="element-375">
            <span className="font-display text-lg md:text-2xl text-gold leading-none" data-id="element-376">
              {formatTime(timeLeft.seconds)}
            </span>
            <span className="text-[8px] md:text-[9px] text-gray-400 uppercase font-bold tracking-wider mt-0.5" data-id="element-377">
              Seg
            </span>
          </div>
        </div>

        {/* Right: Cupos progress */}
        <div className="flex items-center gap-2 md:gap-3 w-full md:w-auto md:min-w-[200px] md:max-w-[260px]" data-id="element-378">
          <Users size={14} className="text-gold shrink-0 hidden md:block" data-id="element-379" />
          <div className="flex-1" data-id="element-380">
            <div className="flex justify-between text-[9px] md:text-[10px] font-bold mb-0.5" data-id="element-381">
              <span className="text-gray-300 uppercase tracking-wider" data-id="element-382">
                Cupos
              </span>
              <span className="text-gold" data-id="element-383">68% TOMADOS</span>
            </div>
            <div className="h-1.5 md:h-2 bg-gray-800 rounded-full overflow-hidden border border-gray-700" data-id="element-384">
              <div className="h-full bg-gradient-to-r from-gold to-gold-dark w-[68%] rounded-full" data-id="element-385"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}